import {IUITipoDePontuacaoLoja} from "./IUITipoDePontuacaoLoja";

export class IUITipoDePontuacaoPorCashback implements IUITipoDePontuacaoLoja {
  constructor(private empresa: any, private tipoDePontuacao: any, private tipoDeAcumulo: string, private atividade: any) {
  }

  calculePontos(valorVenda: number) {
    if (!valorVenda) return 0;

    if (this.atividade.plano.valorMinimoPontuar && this.atividade.plano.valorMinimoPontuar > valorVenda)
      return 0;

    return Number((Math.round(valorVenda * this.atividade.cashback * 100) / 100).toFixed(2));

  }

  obtenhaPontosFormatado(valorVenda: number) {
    let cashback = this.calculePontos(valorVenda);

    if(!cashback) return null;

    return String(`R$ ${cashback.toFixed(2).replace('.', ',')}`)
  }
}
